export const TID = {
  login: {
    form: "login-form",
    password: "login-password-input",
    submit: "login-submit-button",
    error: "login-error-message",
  },
  gateway: {
    root: "gateway-page",
    tab: (k) => `gateway-tab-${k}`,
    // Config tab
    apiName: "gateway-config-name",
    apiId: "gateway-config-id",
    apiBaseUrl: "gateway-config-base-url",
    apiNotes: "gateway-config-notes",
    apiSave: "gateway-config-save",
    // Keys tab
    issueKeyBtn: "gateway-issue-key",
    keyName: "gateway-issue-key-name",
    keyRow: (id) => `gateway-key-row-${id}`,
    keyRevoke: (id) => `gateway-key-revoke-${id}`,
    keyDelete: (id) => `gateway-key-delete-${id}`,
    keyRevealDialog: "gateway-key-reveal-dialog",
    keyCopyBtn: "gateway-key-copy",
    // Engines tab (legacy)
    addEngineBtn: "gateway-add-engine",
    engineRow: (id) => `gateway-engine-row-${id}`,
    engineDeleteBtn: (id) => `gateway-engine-delete-${id}`,
    engineEditBtn: (id) => `gateway-engine-edit-${id}`,
    engineDialog: "gateway-engine-dialog",
    engineField: (k) => `gateway-engine-field-${k}`,
    engineSubmit: "gateway-engine-submit",
    engineAddModelBtn: "gateway-engine-add-model",
    // Web targets tab
    addWebTargetBtn: "gateway-add-web-target",
    webTargetRow: (id) => `gateway-web-target-row-${id}`,
    webTargetDelete: (id) => `gateway-web-target-delete-${id}`,
    webTargetEdit: (id) => `gateway-web-target-edit-${id}`,
    webTargetRun: (id) => `gateway-web-target-run-${id}`,
    webTargetDialog: "gateway-web-target-dialog",
    webTargetField: (k) => `gateway-web-target-field-${k}`,
    webTargetSubmit: "gateway-web-target-submit",
    webTargetRunDialog: "gateway-web-target-run-dialog",
    webTargetRunPrompt: "gateway-web-target-run-prompt",
    webTargetRunSend: "gateway-web-target-run-send",
    webTargetRunResult: "gateway-web-target-run-result",
    webTargetRunError: "gateway-web-target-run-error",
    // Routes tab
    addRouteBtn: "gateway-add-route",
    routeRow: (alias) => `gateway-route-row-${alias}`,
    routeDelete: (alias) => `gateway-route-delete-${alias}`,
    routeDialog: "gateway-route-dialog",
    routeField: (k) => `gateway-route-field-${k}`,
    routeSubmit: "gateway-route-submit",
    routeTargetType: (t) => `gateway-route-target-type-${t}`,
  },
  layout: {
    sidebar: "sidebar-nav",
    navLink: (key) => `nav-link-${key}`,
    logout: "sidebar-logout-button",
    statusBadge: "sidebar-status-badge",
    mobileTopbar: "mobile-topbar",
    mobileMenuButton: "mobile-menu-button",
  },
  dashboard: {
    root: "dashboard-page",
    stat: (k) => `dashboard-stat-${k}`,
  },
  connections: {
    root: "connections-page",
    addButton: "add-connection-button",
    card: (id) => `connection-card-${id}`,
    connect: (id) => `connection-connect-${id}`,
    test: (id) => `connection-test-${id}`,
    disconnect: (id) => `connection-disconnect-${id}`,
    delete: (id) => `connection-delete-${id}`,
    dialog: "add-connection-dialog",
    fieldName: "add-connection-name",
    fieldUrl: "add-connection-url",
    fieldType: "add-connection-type",
    fieldNotes: "add-connection-notes",
    submit: "add-connection-submit",
  },
  settings: {
    root: "settings-page",
    n8nBase: "settings-n8n-base",
    n8nKey: "settings-n8n-key",
    n8nWebhook: "settings-n8n-webhook",
    kraiBase: "settings-krai-base",
    kraiToken: "settings-krai-token",
    save: "settings-save-button",
  },
  n8n: { root: "n8n-page" },
  engines: {
    root: "engines-page",
    addButton: "engine-add-button",
    card: (id) => `engine-card-${id}`,
    test: (id) => `engine-test-${id}`,
    edit: (id) => `engine-edit-${id}`,
    delete: (id) => `engine-delete-${id}`,
    dialog: "engine-dialog",
    fId: "engine-field-id",
    fName: "engine-field-name",
    fProvider: "engine-field-provider",
    fAdapter: "engine-field-adapter",
    fActive: "engine-field-active",
    fConfig: (k) => `engine-config-${k}`,
    fSecret: (k) => `engine-secret-${k}`,
    fCapabilities: "engine-field-capabilities",
    fNotes: "engine-field-notes",
    submit: "engine-submit",
    testDialog: "engine-test-dialog",
    testPrompt: "engine-test-prompt",
    testSend: "engine-test-send",
    testResult: "engine-test-result",
    testError: "engine-test-error",
  },
  webServices: {
    root: "web-services-page",
    addButton: "web-service-add-button",
    card: (id) => `web-service-card-${id}`,
    test: (id) => `web-service-test-${id}`,
    edit: (id) => `web-service-edit-${id}`,
    delete: (id) => `web-service-delete-${id}`,
    healthBanner: "web-services-health-banner",
    dialog: "web-service-dialog",
    fieldName: "web-service-name",
    fieldUrl: "web-service-url",
    fieldUser: "web-service-user",
    fieldMethod: "web-service-method",
    fieldNotes: "web-service-notes",
    fieldPassword: "web-service-password",
    fieldProfile: "web-service-profile",
    fieldLoggedInSel: "web-service-logged-in-selector",
    warnNoStorageState: "web-service-warn-no-storage-state",
    warnMissingSelector: "web-service-warn-missing-selector",
    submit: "web-service-submit",
  },
  browser: {
    root: "browser-page",
    healthBadge: "browser-health-badge",
    refreshHealth: "browser-refresh-health",
    createProfile: "browser-create-profile-button",
    createDialog: "browser-create-dialog",
    createName: "browser-create-name",
    createSubmit: "browser-create-submit",
    profileRow: (n) => `browser-profile-row-${n}`,
    uploadBtn: (n) => `browser-upload-${n}`,
    verifyBtn: (n) => `browser-verify-${n}`,
    deleteBtn: (n) => `browser-delete-${n}`,
    uploadDialog: "browser-upload-dialog",
    uploadFile: "browser-upload-file",
    uploadSubmit: "browser-upload-submit",
    verifyDialog: "browser-verify-dialog",
    verifyUrl: "browser-verify-url",
    verifySelector: "browser-verify-selector",
    verifySubmit: "browser-verify-submit",
    verifyResult: "browser-verify-result",
  },
  kraiApi: { root: "krai-api-page" },
  system: { root: "system-page" },
  sessions: {
    root: "sessions-page",
    addButton: "sessions-add-button",
    card: (n) => `session-card-${n}`,
    check: (n) => `session-check-${n}`,
    use: (n) => `session-use-${n}`,
    close: (n) => `session-close-${n}`,
    delete: (n) => `session-delete-${n}`,
    removeScript: (n) => `session-remove-script-${n}`,
    dialog: "session-dialog",
    fieldName: "session-name",
    fieldUrl: "session-url",
    fieldLoginUrl: "session-login-url",
    fieldLoggedInSel: "session-logged-in-selector",
    fieldMethod: "session-method",
    fieldUserSel: "session-user-selector",
    fieldPassSel: "session-pass-selector",
    fieldSubmitSel: "session-submit-selector",
    fieldPreClick: "session-pre-click-selector",
    fieldSuccessUrl: "session-success-url-pattern",
    fieldIframeSel: "session-iframe-selector",
    fieldMfaSel: "session-mfa-wait-selector",
    fieldSteps: "session-steps-json",
    fieldUser: "session-user",
    fieldPass: "session-pass",
    fieldScript: "session-script",
    submit: "session-submit",
  },
  aiModels: {
    root: "ai-models-page",
    addButton: "ai-models-add-button",
    card: (id) => `ai-model-card-${id}`,
    test: (id) => `ai-model-test-${id}`,
    edit: (id) => `ai-model-edit-${id}`,
    delete: (id) => `ai-model-delete-${id}`,
    health: (id) => `ai-model-health-${id}`,
    dialog: "ai-model-dialog",
    fId: "ai-model-id",
    fName: "ai-model-name",
    fUrl: "ai-model-url",
    fProfile: "ai-model-profile",
    fProfileType: "ai-model-profile-type",
    fPromptSel: "ai-model-prompt-selector",
    fSubmitSel: "ai-model-submit-selector",
    fRespSel: "ai-model-response-selector",
    fReadySel: "ai-model-ready-selector",
    fNotes: "ai-model-notes",
    submit: "ai-model-submit",
    testDialog: "ai-model-test-dialog",
    testPrompt: "ai-model-test-prompt",
    testSend: "ai-model-test-send",
    testResult: "ai-model-test-result",
  },
  providers: {
    root: "providers-page",
    addButton: "providers-add-button",
    card: (id) => `provider-card-${id}`,
    test: (id) => `provider-test-${id}`,
    chat: (id) => `provider-chat-${id}`,
    edit: (id) => `provider-edit-${id}`,
    delete: (id) => `provider-delete-${id}`,
    models: (id) => `provider-models-${id}`,
    dialog: "provider-dialog",
    fId: "provider-id",
    fName: "provider-name",
    fBase: "provider-base-url",
    fAuth: "provider-auth-style",
    fHeader: "provider-auth-header",
    fQuery: "provider-auth-query",
    fKey: "provider-api-key",
    fNotes: "provider-notes",
    submit: "provider-submit",
    modelsDialog: "provider-models-dialog",
    modelsList: "provider-models-list",
    modelsAdd: "provider-models-add",
    modelsAddInput: "provider-models-add-input",
    modelsRefresh: "provider-models-refresh",
    chatDialog: "provider-chat-dialog",
    chatModel: "provider-chat-model",
    chatPrompt: "provider-chat-prompt",
    chatSend: "provider-chat-send",
    chatResult: "provider-chat-result",
  },
};
